import { TranslateResult } from 'vue-i18n';

interface NotificationService {
  notification: Notification | null;
  active: boolean;
  show: Function;
  success: Function;
  error: Function;
  hide: Function;
}

export interface Notification {
  status: boolean;
  message: string | TranslateResult;
  description: string;
  timeout: number;
}

export default {
	notification: null,
	active: false,
	show(status: boolean, message: string | TranslateResult, description = '', timeout = 7000): void {
		this.notification = { status, message, description, timeout };
		this.active = true;
		setTimeout(() => this.hide(), timeout);
	},
	success(message: string | TranslateResult, description = ''): void {
		this.show(true, message, description);
	},
	error(message: string | TranslateResult, description = ''): void {
		this.show(false, message, description);
	},
	hide(): void {
		this.active = false;
	}
} as NotificationService;
